var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00006C7.58172 4.00006 4 7.58178 4 12.0001C4 16.4183 7.58172 20.0001 12 20.0001C16.4183 20.0001 20 16.4183 20 12.0001C20 7.58178 16.4183 4.00006 12 4.00006ZM2 12.0001C2 6.47721 6.47715 2.00006 12 2.00006C17.5228 2.00006 22 6.47721 22 12.0001C22 17.5229 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.5229 2 12.0001Z",
    fill: "#0156CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0001C12.5523 10.0001 13 10.4478 13 11.0001V17.0001C13 17.5523 12.5523 18.0001 12 18.0001C11.4477 18.0001 11 17.5523 11 17.0001V11.0001C11 10.4478 11.4477 10.0001 12 10.0001Z",
    fill: "#0156CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.50006C13.5 8.32849 12.8284 9.00006 12 9.00006C11.1716 9.00006 10.5 8.32849 10.5 7.50006C10.5 6.67163 11.1716 6.00006 12 6.00006C12.8284 6.00006 13.5 6.67163 13.5 7.50006Z",
    fill: "#0156CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLight);
export default __webpack_public_path__ + "static/media/info-light.b5ba497b84e3e9eb3d4e9accf0980b5a.svg";
export { ForwardRef as ReactComponent };